import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addDestination, fetchAllDestination } from '../../../../../Redux/slice/features/destinationSlice'
import { fetchDistrict } from '../../../../../Redux/slice/features/districtSlice'

const AddDestination = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { destinationData, status, error } = useSelector((state) => state.destination);
    const alldistrict=useSelector((state)=> state.district.districtData);
  
    useEffect(() => {
        dispatch(fetchDistrict());
      }, [dispatch]);

    const [formData, setFormData] = useState({
      district: "",
      code: "",
      destination: "",
      category: "",
      attractionpoint: "",
    });

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const validateForm = () => {
        let newErrors = {};
        if (!formData.district) newErrors.district = "District is required";
        if (!formData.code) {
          newErrors.code = "District Code is required";
        } else if (!/^[0-9]+$/.test(formData.code)) {
          newErrors.code = "Only numbers are allowed";
        }
        if (!formData.destination) {
          newErrors.destination = "Destination is required";
        }  else if (!/^[A-Za-z\s]+$/.test(formData.destination)) {
          newErrors.destination = "Only alphabets are allowed";
        }
        if (!formData.category) newErrors.category = "Category is required";
        if (!formData.attractionpoint) {
          newErrors.attractionpoint = "Attraction Point is required";
        }     
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0; // If no errors, return true
      };
    
     
      const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
          dispatch(addDestination(formData)).then(() => {
            alert("Destination Added Successfully!");
            setFormData({ district: "", code: "", destination: "", category: "", attractionpoint: "" });
            setErrors({}); // Clear errors on success
            dispatch(fetchAllDestination());
            
          });
        }
      };
  
  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
        <div className="row g-3">
            <div className="col-sm-12">
              <div className="d-flex align-items-center justify-content-between flex-wrap">
                  <h3 className="fw-bold mb-0">Create Destination</h3>
              </div>
            </div>
            <div className="col-sm-12">
               
                <div className="card mb-3">                    
                    <div className="card-body">
                    <form onSubmit={handleSubmit}>

                        <div className="row g-3">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="form-label text-muted">District </label>
                                    <div className="input-group">
                                        
                                        <select className="form-select"  name="district"
                      value={formData.district}
                      onChange={handleChange}>
                                            <option defaultValue='selected'>Select District</option>
                                            {alldistrict.map((districts) => (
                                                <option key={districts.id} value={districts.district_name}>
                                                    {districts.district_name}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.district && <p className="text-danger">{errors.district}</p>}
                                    </div>
                                </div>
                            </div>
                           
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="form-label text-muted">District Code</label>
                                    <div className="input-group">
                                        
                                        <input type="text" className="form-control" name="code"
                      value={formData.code}
                      onChange={handleChange} />
                      {errors.code && <p className="text-danger">{errors.code}</p>}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="form-label text-muted">Destination</label>
                                    <div className="input-group">
                                        
                                        <input type="text" className="form-control" name="destination"
                      value={formData.destination}
                      onChange={handleChange}
                    />
                    {errors.destination && <p className="text-danger">{errors.destination}</p>}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="form-label text-muted">Category</label>
                                    <div className="input-group">
                                       
                                        <select className="form-select" name="category"
                      value={formData.category}
                      onChange={handleChange}
                    >
                      <option value="">Select Category</option>
                      <option value="A">A</option>
                      <option value="B">B</option>
                      <option value="C">C</option>
                    </select>
                    {errors.category && <p className="text-danger">{errors.category}</p>}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="form-label text-muted">Attraction point</label>
                                    <div className="input-group">
                                                                               
                                        <input type="text" className="form-control" name="attractionpoint"
                      value={formData.attractionpoint}
                      onChange={handleChange}
                    />
                    {errors.attractionpoint && <p className="text-danger">{errors.attractionpoint}</p>}
                                    </div>
                                </div>
                            </div>

                            
                        </div>
                        <div className="col-md-12">
                        <button type="submit" className="btn">
                      {status === "loading" ? "Saving..." : "Save"}
                    </button>
                    {status === "failed" && <p className="text-danger">{error}</p>}
                        </div>
</form>

                    </div>
                </div>
               
            </div>
           
           
        </div>
    </div>
  )
}

export default AddDestination